import type React from 'react'
import { Link } from 'react-router'

interface DropdownItemProps {
    tag?: 'a' | 'button'
    href?: string
    onClick?: () => void
    onItemClick?: () => void
    baseClassName?: string
    className?: string
    children: React.ReactNode
    disabled?: boolean
}

export const DropdownItem: React.FC<DropdownItemProps> = ({
    tag = 'button',
    href,
    onClick,
    onItemClick,
    disabled = false,
    baseClassName = 'block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900',
    className = '',
    children
}) => {
    const combinedClasses = `${baseClassName} ${className} ${disabled ? 'cursor-not-allowed opacity-50' : ''}`.trim()

    const handleClick = (event: React.MouseEvent) => {
        if (disabled) return
        if (onClick) onClick()
        if (onItemClick) onItemClick()
    }

    if (tag === 'a' && href) {
        return (
            <Link to={disabled ? '#' : href} className={combinedClasses} onClick={handleClick}>
                {children}
            </Link>
        )
    }

    return (
        <button onClick={handleClick} className={combinedClasses} disabled={disabled}>
            {children}
        </button>
    )
}
